module.exports = __webpack_public_path__ + "static/media/icon-arrow-top.541da9eb.svg";